<div class="mf-trt-document rounded w-100 h-100">
    <form [formGroup]="documentsForm" (ngSubmit)="onSubmitAddDocument()" novalidate>
        <div class="p-2 d-flex mf-tools border-bottom">
            <div class="w-100"></div>
            <i
                (click)="changeView()"
                ngbTooltip="Spremeni pogled"
                container="body"
                class="la"
                [ngClass]="{
                    'la- la-th-list': customerDocumentViewType === 'LARGE',
                    'la- la-table': customerDocumentViewType === 'LIST',
                    'la- la-th-large': customerDocumentViewType === 'SMALL'
                }"
            ></i>

            <i
                (click)="addOrCancel()"
                ngbTooltip="Pokaži/skrij dodajanje dokumenta"
                container="body"
                class="la"
                [ngClass]="isVisibleInput ? 'la-minus' : 'la-plus'"
            ></i>
        </div>
        <div *ngIf="isVisibleInput" class="upload px-2">
            <div class="m-list-search pb-2">
                <div class="m-list-search__results">
                    <div class="m-list-search__result-item">
                        <span class="m-list-search__result-item-icon">
                            <i
                                ngbTooltip="Ime datoteke"
                                class="la la-paperclip m--font-inverse-light"
                                i18n-ngbTooltip="@@customer.documents.document.name"
                            ></i>
                        </span>
                        <span class="m-list-search__result-item-text">
                            <div class="custom-file">
                                <input (change)="selectFile($event)" type="file" formControlName="uploadFile" value="" class="custom-file-input" />
                                <label *ngIf="!selectedFilesForUpload" for="customFile" style="overflow: hidden" class="custom-file-label">
                                    Izberi datoteko
                                </label>
                                <label *ngIf="selectedFilesForUpload" for="customFile" style="overflow: hidden" class="custom-file-label">
                                    {{ selectedFilesForUpload[0].name }}
                                </label>
                            </div>
                        </span>
                    </div>
                    <div class="m-list-search__result-item">
                        <span class="m-list-search__result-item-icon">
                            <i
                                ngbTooltip="Naziv datoteke"
                                class="la-i-cursor la m--font-inverse-light"
                                i18n-ngbTooltip="@@customer.documents.document.title"
                            ></i>
                        </span>
                        <span class="m-list-search__result-item-text">
                            <input formControlName="comment" type="text" placeholder="Naziv (opcijsko)" class="form-control m-input" />
                        </span>
                    </div>
                </div>
            </div>
            <div>
                <div *ngIf="percentDone" class="progress m-progress--sm">
                    <div
                        [style.width.%]="percentDone"
                        aria-valuemax="100"
                        aria-valuemin="0"
                        aria-valuenow="100"
                        role="progressbar"
                        class="progress-bar m--bg-primary"
                    ></div>
                </div>

                <button type="submit" class="m--align-right mt-2 mb-2 btn btn-outline-accent m-btn m-btn--custom m-btn--icon m-btn--pill btn-block">
                    <span>
                        <i class="la la-check"></i>
                        <span>Naloži</span>
                    </span>
                </button>
            </div>
            <hr />
        </div>
        <div *ngIf="numberOfElements < 1" class="p-2">Ni datotek.</div>
        <div
            class="m-widget4 p-1"
            [ngClass]="{
                'd-flex justify-content-around flex-wrap': customerDocumentViewType === 'LARGE' || customerDocumentViewType === 'SMALL'
            }"
        >
            <common-document-list-element
                *ngFor="let doc of allDocuments?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)"
                [document]="doc"
                [isReadOnly]="false"
                [setThumbnail]="inputData"
                [termData]="termData"
                [showCreationLocation]="true"
                (onOpenDocument)="openMediaViewDialog(doc)"
                (onDelete)="removeDocumetFromlist($event, doc)"
                (onDownloadDocument)="downloadDocument(doc)"
                (attachToHD)="attachToHDChat(doc)"
                class="document-element"
            ></common-document-list-element>
        </div>
        <ngb-pagination
            *ngIf="numberOfElements > itemsPerPage"
            [(page)]="currentPage"
            [collectionSize]="numberOfElements"
            [pageSize]="itemsPerPage"
            [directionLinks]="numberOfElements > itemsPerPage * 4"
            [maxSize]="4"
            class="d-flex justify-content-center align-self-end mt-2"
        ></ngb-pagination>
    </form>
</div>
